import {useContext, useState} from "react";
import AuthContext from "../Services/AuthContext";
import {AppBar, Box, Button, Container, Menu, Toolbar} from "@mui/material";
import {Avatar} from "@fluentui/react-components";
import SignButtons from "./SignButtons";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {Link} from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import logo from '.././logo-transparent.png';

function MainNav() {

    const [user] = useContext(AuthContext);

    const settings = [
        {name: 'Profil', link: '/profile'},
        {name: 'Wyloguj', link: '/logout'}
    ]
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const [anchorElUser, setAnchorElUser] = useState(null);

    const profileButtons = user.token !== '' ? <>
            <Tooltip title="Ustawienia">
                <Button onClick={handleOpenUserMenu} sx={{p: 0, display: {xs: 'flex', md: 'none'}}}>
                    <Avatar color={'magenta'} alt={user.username} src="/static/images/avatar/2.jpg"/>
                </Button>
                <Button onClick={handleOpenUserMenu} sx={{p: 0, display: {xs: 'none', md: 'flex'}}}>
                    <Avatar color={'magenta'} alt={user.username} src="/static/images/avatar/2.jpg"/>
                    <Typography sx={{textAlign: 'center', color: 'black', ml: 1}}>{user.username}</Typography>
                </Button>
            </Tooltip>
            <Menu
                sx={{mt: '45px'}}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                <MenuItem sx={{display: {xs: 'flex', md: 'none', width: '180px', textAlign: 'center'}}}>
                    <Typography sx={{textAlign: 'center', color: 'black', width: '100%'}}>{user.username}</Typography>
                </MenuItem>
                {settings.map((setting, index) => (
                    <MenuItem key={index} onClick={handleCloseUserMenu} sx={{width: '180px', textAlign: 'center'}}>
                        <Link to={setting.link} style={{width: '100%'}}><Button fullWidth>{setting.name}</Button></Link>
                    </MenuItem>
                ))}
            </Menu></>
        : <SignButtons/>;
    let menu = [
        {name: 'Dla Organizatorów', link: '/dla-organizatorow'},
        {name: 'Kontakt', link: '/kontakt'},
    ];
    if (user.token !== '') {
        menu = [
            {name: 'Moje Zapisy', link: '/registrations'},
            {name: 'Moje Dzieci', link: '/children'},
        ];
        if (user.facilities?.length > 0) {
            menu = [
                ...menu,
                {name: 'Sezony', link: '/season'},
                {name: 'Organizatorzy', link: '/organizer'},
                {name: 'Wydarzenia', link: '/camps'}
            ];
        }
    }
    const [anchorElNav, setAnchorElNav] = useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };


    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };


    return (<AppBar position="static" color={'transparent'} sx={{mb: 3}}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
{/*                    <Box sx={{ height: '50px', display: {xs: 'flex', md: 'none'}}}>
                        <Link to={'/'} ><img src={logo} style={{height: '100%'}} alt="logo"/></Link>
                    </Box>*/}
                    <Box sx={{ maxHeight: '100px', height: '15vw'}}>
                        <Link to={'/'} ><img src={logo} style={{height: '100%'}} alt="logo"/></Link>
                    </Box>
                    <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{display: {xs: 'block', md: 'none'}}}
                        >
                            {menu.map((page, index) => (
                                <MenuItem key={index} onClick={handleCloseNavMenu}>
                                    <Link to={page.link}><Typography sx={{textAlign: 'center'}}>{page.name}</Typography></Link>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    {/*<Link to={'/'} ><img src={logo} style={{display: {xs: 'flex', md: 'none'}, mr: 1}} alt="logo"/></Link>*/}
                    <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                        {menu.map((page, index) => (
                            <Link to={page.link} key={index}>
                                <Button color={'anthracite'}>
                                    {page.name}
                                </Button>
                            </Link>
                        ))}
                    </Box>
                    <Box sx={{flexGrow: 0}}>
                        {profileButtons}
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    )
}

export default MainNav;